import { render, staticRenderFns } from "./ReviewsSection.vue?vue&type=template&id=44a8f253&scoped=true"
import script from "./ReviewsSection.vue?vue&type=script&lang=js"
export * from "./ReviewsSection.vue?vue&type=script&lang=js"
import style0 from "./ReviewsSection.vue?vue&type=style&index=0&id=44a8f253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8f253",
  null
  
)

export default component.exports